import { Outlet } from 'react-router-dom';

// project import
import Footer from './Footer';

// types
import { SimpleLayoutType } from 'types/config';

// ==============================|| LAYOUT - SIMPLE / LANDING ||============================== //
//
// Footer は lazy にしていない。プリレンダリングしたHTMLを hydrateRoot で引き継ぐとき、
// 未解決の lazy があると Suspense の fallback が描画されて本文と食い違い、
// ハイドレーションに失敗するため(詳細は src/routes/index.tsx のコメント)。

const SimpleLayout = ({ layout = SimpleLayoutType.SIMPLE }: { layout?: SimpleLayoutType }) => {
  return (
    <>
      <Outlet />
      <Footer />
    </>
  );
};

export default SimpleLayout;
